export var RebateType;
(function (RebateType) {
    RebateType["BRAND"] = "Brand";
    RebateType["GENERIC"] = "Generic";
})(RebateType || (RebateType = {}));
export var PvaType;
(function (PvaType) {
    // McKesson Contract Types
    PvaType["IPC_OPTION_1"] = "IPC Option 1";
    PvaType["IPC_OPTION_2"] = "IPC Option 2";
    PvaType["IPC_218"] = "IPC 218";
    PvaType["IPC_USAVE"] = "IPC USave";
    PvaType["MID_MARKET_UNAFFILIATED"] = "Mid Market Unaffiliated";
    PvaType["LEGACY_APCI_STANDARD"] = "Legacy APCI Standard";
    PvaType["LEGACY_APCI_GCR"] = "Legacy APCI GCR";
    PvaType["APCI_2026_STANDARD"] = "2026 APCI Standard";
    PvaType["APCI_2026_SCRUB_GCR_ONLY"] = "2026 APCI Scrub GCR Only";
    PvaType["VALUE_AGREEMENT"] = "Value Agreement";
    // Cardinal Contract Types
    PvaType["AAP_STANDARD"] = "AAP Standard";
    PvaType["AAP_ALTERNATIVE"] = "AAP Alternative";
    PvaType["AAP_CORE"] = "AAP Core";
    PvaType["NEXUS"] = "Nexus";
})(PvaType || (PvaType = {}));
export var GcrItemType;
(function (GcrItemType) {
    GcrItemType["SPECIALTY"] = "Specialty";
    GcrItemType["GLP1S"] = "GLP1's";
    GcrItemType["FLU_COVID_VACCINES"] = "Flu and Covid Vaccines";
    GcrItemType["DEXCOM"] = "Dexcom";
    GcrItemType["DROPSHIP"] = "Dropship";
    GcrItemType["MIGRAINE"] = "Migraine";
    GcrItemType["ANTI_DIABETICS"] = "Anti-Diabetics";
    GcrItemType["ANTI_PSYCHOTICS"] = "Anti-Psychotics";
})(GcrItemType || (GcrItemType = {}));
;
